import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "uploadArea",
    "selectedFileDisplay",
    "fileInput",
    "fileName",
    "submitButton"
  ]

  connect() {
    this.updateSubmitButton()
  }

  openFilePicker() {
    this.fileInputTarget.click()
  }

  handleFileSelect(event) {
    const file = event.target.files[0]
    if (file) {
      this.displaySelectedFile(file)
    }
  }

  handleDragOver(event) {
    event.preventDefault()
    event.stopPropagation()
    this.uploadAreaTarget.classList.add('drag-over')
  }

  handleDragLeave(event) {
    event.preventDefault()
    event.stopPropagation()
    this.uploadAreaTarget.classList.remove('drag-over')
  }

  handleDrop(event) {
    event.preventDefault()
    event.stopPropagation()
    this.uploadAreaTarget.classList.remove('drag-over')

    const files = event.dataTransfer.files
    if (files.length > 0) {
      const file = files[0]

      // Check if it's a CSV file
      if (this.isCSVFile(file)) {
        // Set the file to the input
        const dataTransfer = new DataTransfer()
        dataTransfer.items.add(file)
        this.fileInputTarget.files = dataTransfer.files

        this.displaySelectedFile(file)
      } else {
        alert('Please select a CSV file')
      }
    }
  }

  displaySelectedFile(file) {
    if (!this.isCSVFile(file)) {
      alert('Please select a CSV file')
      return
    }

    this.fileNameTarget.textContent = file.name
    this.uploadAreaTarget.classList.add('d-none')
    this.selectedFileDisplayTarget.classList.remove('d-none')
    this.updateSubmitButton()
  }

  removeFile() {
    this.fileInputTarget.value = ''
    this.uploadAreaTarget.classList.remove('d-none')
    this.selectedFileDisplayTarget.classList.add('d-none')
    this.updateSubmitButton()
  }

  updateSubmitButton() {
    const hasFile = this.fileInputTarget.files && this.fileInputTarget.files.length > 0
    this.submitButtonTarget.disabled = !hasFile

    if (hasFile) {
      this.submitButtonTarget.classList.remove('btn-disabled')
    } else {
      this.submitButtonTarget.classList.add('btn-disabled')
    }
  }

  isCSVFile(file) {
    return file.type === 'text/csv' ||
           file.type === 'application/csv' ||
           file.name.toLowerCase().endsWith('.csv')
  }
}